<template>
  <div class="borrowed-record-container">
    <div class="list-container">
      <van-pull-refresh v-model="refreshing" class="refresh-container" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getList('push')">
          <div class="list" v-for="(item, index) in list" :key="index">
            <div class="list-item">
              <div class="item-left">
                <img :src="item.bookPic | thumbnailImg" class='book-pic'/>
              </div>
              <div class="item-right">
                <div class="item-top">
                  <span v-if="item.bookStatus === 2" class="book-theme">在借</span>
                  <span :class="item.bookStatus === 2 ? 'borrowing' : ''" class='book-title'>{{ item.bookName }}</span>
                  <span class="book-desc">{{ item.recommendDesc }}</span>
                </div>
                <div class="item-bottom">
                  <span class="borrowed-time">借阅时间：{{ item.borrowedTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { api } from '@/api/index'
import { List, PullRefresh } from 'vant'

export default {
  name: 'CourseList',
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      refreshing: false, // 顶部刷新状态
      loading: false, // 是否处于加载状态
      finished: false, // 是否数据加载完成
      cardId: '', // 借阅卡ID
      aId: '', // 代理商ID
      uId: '',
      pageSize: 12,
      list: []
    }
  },
  created() {
    this.cardId = this.$route.query.cardId || ''
    this.aId = this.$route.query.aId || ''
    this.uId = this.$route.query.uId || ''
  },
  methods: {
    onRefresh() {
      this.loading = false
      this.finished = false
      this.getList('update')
    },
    getList(type) {
      let pageId = ''
      if (this.list.length !== 0 && type === 'push') {
        pageId = this.list[this.list.length - 1].id
      } else {
        pageId = ''
      }
      api.getBorrowedRecordList({
        cardId: this.cardId,
        aId: this.aId,
        uId: this.uId,
        pageId: pageId,
        pageSize: this.pageSize
      }).then(res => {
        this.refreshing = false
        if (res.code === 10000) {
          if (type === 'push') {
            this.list = this.list.concat(res.data)
            this.loading = false
            if (res.data.length < this.pageSize) {
              this.loading = true
              this.finished = true
            }
          } else {
            this.list = res.data
            this.loading = false
            if (res.data.length < this.pageSize) {
              this.loading = true
              this.finished = true
            }
          }
        }
      }).catch(() => {
        this.refreshing = false
      })
    }
  }
}
</script>

<style scoped>
.borrowed-record-container {
  position: relative;
  min-width: 320px;
}

.list-container {
  position: relative;
  max-width: 414px;
  margin: 20px auto;
  padding: 0 15px;
  box-sizing: border-box;
}

.list {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 auto 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, .2);
}

.list-item {
  position: relative;
  width: 100%;
  height: 170px;
}

.item-left {
  position: absolute;
  width: 35%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.book-pic {
  max-width: 100px;
  max-height: 130px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
}

.item-right {
  position: absolute;
  width: 65%;
  height: 100%;
  top: 0;
  right: 0;
}

.item-top {
  position: absolute;
  width: 100%;
  height: 70%;
  top: 0;
  left: 0;
}

.item-bottom {
  position: absolute;
  width: 100%;
  height: 30%;
  bottom: 0;
  left: 0;
}

.borrowed-time {
  position: relative;
  font-size: 12px;
  color: #ccc;
  top: 5px;
}

.book-theme {
  position: absolute;
  width: 40px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  text-align: center;
  left: 5px;
  top: 27px;
  font-size: 13px;
  color: #fff;
  background-color: #AF8FFE;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.book-title {
  position: absolute;
  width: 70%;
  left: 0;
  top: 27px;
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-title.borrowing {
  left: 55px;
}

.book-desc {
  position: absolute;
  width: 90%;
  left: 0;
  top: 65px;
  font-size: 13px;
  color: #838383;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.refresh-container{
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  padding: 5px;
  box-sizing: border-box;
}

</style>